export default "__VITE_ASSET__Cws0_FoE__"